<template>
  <div class="w-full min-h-screen bg-gradient-to-br from-gray-25 to-gray-50 p-2 rounded-lg">
    <div class="mb-8">
      <div class="flex items-start justify-between  bg-white p-4 rounded-lg mb-2">
        <div class="ml-5">
          <div class="flex items-center gap-3 mb-2">
            <div class="w-2 h-8 bg-gradient-to-b from-blue-500 to-blue-600 rounded-full"></div>
            <h1 class="text-2xl font-bold text-gray-900 tracking-tight">گزارش‌های مالی</h1>
          </div>
        </div>
        <div class="flex items-center gap-1">
          <button
              style="max-width: 100px;"
              @click="refreshActiveTab"
              :disabled="isLoadingActive"
              class="flex items-center justify-center w-8 h-8 rounded-lg bg-blue-500 border border-gray-200 text-gray-50 text-sm font-semibold  hover:border-gray-300 transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed shadow-xs"
              title="بروزرسانی"
          >
            <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
            </svg>
            بروزرسانی
          </button>
          <!--
          <button
              style="max-width: 130px;"
              @click="exportCSV"
              :disabled="isLoadingActive"
              class="text-gray-50 text-sm font-semibold flex items-center justify-center w-8 h-8 rounded-lg bg-green-600 border border-gray-200  hover:border-gray-300 transition-all duration-200 disabled:opacity-40 disabled:cursor-not-allowed shadow-xs"
              title="خروجی CSV"
          >
            <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
            </svg>
            خروجی CSV
          </button>
          -->
        </div>
      </div>

      <div class="flex items-center bg-white p-4 rounded-lg mb-2">
        <div class="flex items-center gap-3">
          <div class="relative">
            <button
                @click="filtersOpen = !filtersOpen"
                class="flex items-center gap-2 px-3 py-2 rounded-lg bg-gray-500 border border-gray-300 text-gray-50  transition-all duration-200 shadow-xs"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.414A1 1 0 013 6.707V4z"></path>
              </svg>
              <span class="text-xs font-medium">فیلترها</span>
              <span v-if="activeFilterCount > 0" class="flex items-center justify-center  text-sm bg-gray-900 text-white rounded-md px-2 py-1">
                <span>{{ activeFilterLabel }}</span>
              </span>
            </button>

            <div
                v-if="filtersOpen"
                class="absolute right-0 top-10 z-30 w-72 bg-white border border-gray-200 rounded-xl shadow-lg p-4"
            >
              <div class="flex items-center justify-between mb-3">
                <span class="text-sm font-semibold text-gray-900">فیلترهای زمانی</span>
                <button
                    @click="filtersOpen = false"
                    class="text-gray-400 hover:text-gray-600 transition-colors p-1"
                >
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                  </svg>
                </button>
              </div>

              <div class="space-y-4">
                <div class="flex items-center justify-between mr-3">
                  <span class="text-xs font-medium text-gray-700 ml-5">نوع فیلتر : </span>
                  <div class="flex bg-gray-100 rounded-lg items-center">
                    <button
                        @click="filterMode = 'preset'"
                        :class="[
                        'text-center px-2 py-1 text-xs rounded-md transition-all 2 block w-full',
                        filterMode === 'preset'
                          ? 'bg-blue-700 text-gray-50 shadow-xs'
                          : 'text-gray-600 '
                      ]"
                    >
                      بازه انتخابی
                    </button>
                    <button
                        @click="filterMode = 'range'"
                        :class="[
                        'text-center px-2 py-1 text-xs rounded-md transition-all block w-full',
                        filterMode === 'range'
                          ? 'bg-blue-700 text-gray-50 shadow-xs'
                          : 'text-gray-600 '
                      ]"
                    >
                      بازه دستی
                    </button>
                  </div>
                </div>

                <div v-if="filterMode === 'preset'">
                  <label class="block text-xs font-medium text-gray-700 mb-2">بازه‌های زمانی</label>
                  <div class="grid grid-cols-2 gap-2">
                    <button
                        v-for="p in presets"
                        :key="p.value"
                        @click="filters.range = p.value"
                        :class="[
                        'px-3 py-2 text-xs rounded-lg border transition-all duration-200',
                        filters.range === p.value
                          ? 'bg-blue-50 border-blue-200 text-blue-700 shadow-xs'
                          : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-50'
                      ]"
                    >
                      {{ p.label }}
                    </button>
                  </div>
                </div>

                <div v-else>
                  <label class="block text-xs font-medium text-gray-700 mb-2">انتخاب بازه</label>
                  <div class="space-y-3">
                    <date-picker
                        v-model="filters.from_jalali"
                        type="date"
                        format="jYYYY-jMM-jDD"
                        display-format="jYYYY/jMM/jDD"
                        placeholder="از تاریخ"
                        auto-submit
                        input-class="w-full px-3 py-2 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                    />
                    <date-picker
                        v-model="filters.to_jalali"
                        type="date"
                        format="jYYYY-jMM-jDD"
                        display-format="jYYYY/jMM/jDD"
                        placeholder="تا تاریخ"
                        auto-submit
                        input-class="w-full px-3 py-2 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                    />
                  </div>
                  <p v-if="validationError" class="text-xs text-red-600 mt-2">{{ validationError }}</p>
                </div>
              </div>

              <div class="flex items-center justify-between pt-4 mt-4 border-t border-gray-200">
                <button
                    @click="applyFiltersAndClose"
                    :disabled="isLoadingAny"
                    class="px-4 py-2 bg-blue-600 text-white text-xs font-medium rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  اعمال فیلتر
                </button>
                <button
                    @click="resetFilters"
                    class="px-3 py-2 text-xs text-gray-600 hover:text-gray-900 transition-colors"
                >
                  بازنشانی
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div v-if="filtersOpen" class="fixed inset-0 z-20" @click="filtersOpen = false"></div>

    <div class="mb-6">
      <div class="flex gap-1 bg-white rounded-lg p-1.5 shadow-xs border border-gray-200 w-fit">
        <button
            v-for="t in tabs"
            :key="t.key"
            @click="activeTab = t.key"
            :class="[
            'px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 min-w-[120px]',
            activeTab === t.key
              ? 'bg-gradient-to-br from-blue-500 to-blue-600 text-white shadow-sm'
              : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
          ]"
        >
          {{ t.label }}
        </button>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-6">
      <div class="col-span-8">
        <div class="bg-white rounded-2xl shadow-sm border border-gray-200 p-8">
          <div v-if="isLoadingActive" class="animate-pulse">
            <div class="h-4 w-40 bg-gray-200 rounded mb-6"></div>
            <div class="h-12 w-64 bg-gray-200 rounded mb-3"></div>
            <div class="h-3 w-32 bg-gray-200 rounded"></div>
          </div>

          <div v-else>
            <div v-if="activeTab === 'sales_gross'" class="text-center">
              <div class="mb-2">
                <div class="text-4xl font-bold text-gray-900 mb-1">
                  {{ formatCurrency(metrics.sales_gross.value) }}
                  <span class="text-lg text-gray-500 font-normal">تومان</span>
                  <div class="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-50 text-blue-700 rounded-md text-xs font-medium mr-5">
                    <div class="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                    فروش ناخالص
                  </div>

                </div>

                <p class="text-sm text-gray-500">مجموع فروش شامل هزینه ارسال</p>
              </div>
              <div class="text-xs text-gray-400 mt-4">
                محدوده: {{ metrics.sales_gross.rangeLabel }}
              </div>
            </div>

            <div v-else-if="activeTab === 'sales_net'" class="text-center">
              <div class="mb-2">
                <div class="text-4xl font-bold text-gray-900 mb-1">
                  {{ formatCurrency(metrics.sales_net.value) }}
                  <span class="text-lg text-gray-500 font-normal">تومان</span>
                  <div class="inline-flex items-center gap-2 px-3 py-1.5 bg-green-50 text-green-700 rounded-md mr-5 text-xs font-medium mb-6">
                    <div class="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
                    فروش خالص
                  </div>

                </div>
                <p class="text-sm text-gray-500">فروش خالص بدون هزینه ارسال</p>
              </div>
              <div class="text-xs text-gray-400 mt-4">
                محدوده: {{ metrics.sales_net.rangeLabel }}
              </div>
            </div>

            <div v-else-if="activeTab === 'profit_gross'" class="text-center">
              <div class="mb-2">
                <div class="text-4xl font-bold text-gray-900 mb-1">
                  {{ formatCurrency(metrics.profit_gross.value) }}
                  <span class="text-lg text-gray-500 font-normal">تومان</span>
                  <div class="inline-flex items-center gap-2 px-3 py-1.5 bg-purple-50 text-purple-700 rounded-md mr-5 text-xs font-medium mb-6">
                    <div class="w-1.5 h-1.5 bg-purple-500 rounded-full"></div>
                    سود ناخالص
                  </div>

                </div>
              </div>
              <div class="text-xs text-gray-400 mt-4">
                محدوده: {{ metrics.profit_gross.rangeLabel }}
              </div>
            </div>

            <!-- Error State -->
            <div v-if="errorMessage" class="mt-6 p-4 bg-red-50 border border-red-200 rounded-xl">
              <div class="flex items-center gap-3 text-red-700">
                <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <div>
                  <p class="text-sm font-medium">{{ errorMessage }}</p>
                  <p class="text-xs mt-1">لطفاً دوباره تلاش کنید یا با پشتیبانی تماس بگیرید</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Top Products (two tables) -->
        <div class="mt-6 grid grid-cols-2 gap-6">
          <!-- Top by Revenue -->
          <div class="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
            <div class="flex items-center justify-between mb-4">
              <h3 class="text-sm font-semibold text-gray-900">پرفروش‌ترین محصولات بر اساس (درآمد)</h3>
              <span class="text-[11px] text-gray-800 font-bold"> {{ TOP_LIMIT }}
              <span class="text-[8px] text-gray-500">محصول برتر</span>
              </span>

            </div>

            <div v-if="loading.top_by_revenue" class="animate-pulse space-y-2">
              <div class="h-4 bg-gray-200 rounded"></div>
              <div class="h-4 bg-gray-200 rounded"></div>
              <div class="h-4 bg-gray-200 rounded"></div>
            </div>
            <div v-else>
              <table class="w-full text-xs">
                <thead>
                <tr class="text-gray-500">
                  <th class="text-right py-2">کالا</th>
                  <th class="text-left py-2">تعداد</th>
                  <th class="text-left py-2">درآمد</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in topProductsByRevenue" :key="'rev-' + row.product_id" class="border-t text-gray-700">
                  <td class="py-2 pr-1">{{ row.name }}</td>
                  <td class="py-2 text-left">{{ formatNumber(row.total_qty) }}</td>
                  <td class="py-2 text-left">{{ formatCurrency(row.total_revenue) }}</td>
                </tr>
                <tr v-if="!topProductsByRevenue.length">
                  <td colspan="3" class="py-6 text-center text-gray-400">داده‌ای یافت نشد</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Top by Quantity -->
          <div class="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
            <div class="flex items-center justify-between mb-4">
              <h3 class="text-sm font-semibold text-gray-900">پرفروش‌ ترین محصولات بر اساس (تعداد)</h3>
              <span class="text-[11px] text-gray-800 font-bold"> {{ TOP_LIMIT }}
              <span class="text-[8px] text-gray-500">محصول برتر</span>
              </span>
            </div>

            <div v-if="loading.top_by_quantity" class="animate-pulse space-y-2">
              <div class="h-4 bg-gray-200 rounded"></div>
              <div class="h-4 bg-gray-200 rounded"></div>
              <div class="h-4 bg-gray-200 rounded"></div>
            </div>
            <div v-else>
              <table class="w-full text-xs">
                <thead>
                <tr class="text-gray-500">
                  <th class="text-right py-2">کالا</th>
                  <th class="text-left py-2">تعداد</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in topProductsByQuantity" :key="'qty-' + row.product_id" class="border-t text-gray-700">
                  <td class="py-2 pr-1">{{ row.name }}</td>
                  <td class="py-2 text-left">{{ formatNumber(row.total_qty) }}</td>
                </tr>
                <tr v-if="!topProductsByQuantity.length">
                  <td colspan="2" class="py-6 text-center text-gray-400">داده‌ای یافت نشد</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

      <!-- Sidebar Stats -->
      <div class="col-span-4">
        <div class="space-y-4">
          <!-- Quick Stats (dynamic) -->
          <div class="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
            <h3 class="text-sm font-semibold text-gray-900 mb-4">آمار سریع</h3>

            <div v-if="loading.sidebar_stats" class="animate-pulse space-y-3">
              <div class="h-4 bg-gray-200 rounded"></div>
              <div class="h-4 bg-gray-200 rounded"></div>
              <div class="h-4 bg-gray-200 rounded"></div>
            </div>

            <div v-else class="space-y-4">
              <div class="flex items-center justify-between">
                <span class="text-xs text-gray-600">تعداد سفارش‌ها</span>
                <span class="text-sm font-medium text-gray-900">{{ formatNumber(quick.orders_count) }}</span>
              </div>
              <div class="flex items-center justify-between">
                <span class="text-xs text-gray-600">هزینه کل ارسال</span>
                <span class="text-sm font-medium text-gray-900">{{ formatCurrency(quick.shipping_total) }}</span>
              </div>
              <div class="flex items-center justify-between">
                <span class="text-xs text-gray-600">تعداد کل آیتم‌ها</span>
                <span class="text-sm font-medium text-gray-900">{{ formatNumber(quick.items_quantity) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'FinancialReportsDashboard',
  data() {
    return {
      TOP_LIMIT: 10,
      filtersOpen: false,
      filterMode: 'preset',
      activeTab: 'sales_gross',
      tabs: [
        { key: 'sales_gross', label: 'فروش ناخالص' },
        { key: 'sales_net', label: 'فروش خالص' },
        { key: 'profit_gross', label: 'سود ناخالص' },
      ],
      presets: [
        { value: 'today', label: 'امروز' },
        { value: 'yesterday', label: 'دیروز' },
        { value: 'current_month', label: 'ماه جاری' },
        { value: 'previous_month', label: 'ماه قبل' },
      ],

      // فیلترها
      filters: {
        range: 'today',
        from_jalali: '',
        to_jalali: '',
        from: '',
        to: '',
      },

      // نتایج متریک‌های اصلی
      metrics: {
        sales_gross: { value: 0, rangeLabel: '' },
        sales_net: { value: 0, rangeLabel: '' },
        profit_gross: { value: 0, rangeLabel: '' },
      },

      // آمار سریع (داینامیک)
      quick: {
        orders_count: 0,
        shipping_total: 0,
        items_quantity: 0,
      },

      // تاپ لیست‌ها
      topProductsByRevenue: [],
      topProductsByQuantity: [],

      // وضعیت‌ها
      loading: {
        sales_gross: false,
        sales_net: false,
        profit_gross: false,
        sidebar_stats: false,
        top_by_revenue: false,
        top_by_quantity: false,
      },
      errorMessage: '',
      validationError: '',
    }
  },
  computed: {
    isLoadingActive() {
      return this.loading[this.activeTab]
    },
    isLoadingAny() {
      return (
          this.loading.sales_gross ||
          this.loading.sales_net ||
          this.loading.profit_gross ||
          this.loading.sidebar_stats ||
          this.loading.top_by_revenue ||
          this.loading.top_by_quantity
      )
    },
    activeFilterCount() {
      let count = 0
      if (this.filterMode === 'preset' && this.filters.range) {
        count = 1
      } else if (this.filterMode === 'range' && (this.filters.from_jalali || this.filters.to_jalali)) {
        count = 1
      }
      return count
    },
    activeFilterLabel() {
      if (this.filterMode === 'preset') {
        const preset = this.presets.find(p => p.value === this.filters.range)
        return preset ? preset.label : 'بدون فیلتر'
      } else {
        if (this.filters.from_jalali && this.filters.to_jalali) {
          return `از ${this.filters.from_jalali} تا ${this.filters.to_jalali}`
        }
        return 'بدون فیلتر'
      }
    },
  },
  mounted() {
    this.fetchAll()
  },
  methods: {
    // Helpers
    presetLabel(val) {
      const f = this.presets.find(p => p.value === val)
      return f ? f.label : ''
    },
    resetFilters() {
      if (this.filterMode === 'preset') {
        this.filters.range = 'today'
      } else {
        this.filters.from_jalali = ''
        this.filters.to_jalali = ''
      }
      this.validationError = ''
    },
    clearFilters() {
      this.resetFilters()
      this.fetchAll()
    },
    buildParams() {
      const params = {}
      if (this.filterMode === 'range') {
        if (!this.filters.from_jalali || !this.filters.to_jalali) {
          this.validationError = 'هر دو تاریخ «از» و «تا» الزامی است.'
          return null
        }
        params.from_jalali = this.filters.from_jalali
        params.to_jalali = this.filters.to_jalali
      } else {
        params.range = this.filters.range || 'today'
      }
      this.validationError = ''
      return params
    },
    rangeLabelFromResponse(res) {
      if (res.range === 'custom') {
        this.filters.from = res.from
        this.filters.to = res.to
        return 'سفارشی'
      }
      this.filters.from = ''
      this.filters.to = ''
      return this.presetLabel(res.range) || ''
    },
    formatCurrency(val) {
      if (val == null) return '0'
      return Number(val).toLocaleString('fa-IR')
    },
    formatNumber(val) {
      if (val == null) return '0'
      return Number(val).toLocaleString('fa-IR')
    },

    // Networking: مجموعه‌خوانی
    fetchAll() {
      // تب اصلی‌ها
      this.fetchSalesGross()
      this.fetchSalesNet()
      this.fetchProfitGross()

      // آمار سریع
      this.fetchQuickStats()

      // تاپ‌لیست‌ها
      this.fetchTopProductsRevenue()
      this.fetchTopProductsQuantity()
    },
    applyFiltersAndClose() {
      const params = this.buildParams()
      if (!params) return
      this.filtersOpen = false
      this.fetchAll()
    },
    refreshActiveTab() {
      const params = self.buildParams ? this.buildParams() : {}
      if (self.buildParams && !params) return
      // فقط تب فعال + آمار سریع و تاپ‌لیست‌ها را هم تازه می‌کنیم
      switch (this.activeTab) {
        case 'sales_gross': this.fetchSalesGross(); break
        case 'sales_net': this.fetchSalesNet(); break
        case 'profit_gross': this.fetchProfitGross(); break
      }
      this.fetchQuickStats()
      this.fetchTopProductsRevenue()
      this.fetchTopProductsQuantity()
    },

    // === متریک‌های اصلی ===
    fetchSalesGross() {
      const params = this.buildParams()
      if (!params) return
      this.loading.sales_gross = true
      this.errorMessage = ''
      this.request({
        url: this.endpoint('saleReports/reports/sales/gross'),
        method: 'get',
        params,
        success: (data) => {
          this.metrics.sales_gross.value = data.value || 0
          this.metrics.sales_gross.rangeLabel = this.rangeLabelFromResponse(data)
          this.loading.sales_gross = false
        },
        error: () => {
          this.loading.sales_gross = false
          this.errorMessage = 'خطا در دریافت فروش ناخالص.'
        }
      })
    },

    fetchSalesNet() {
      const params = this.buildParams()
      if (!params) return
      this.loading.sales_net = true
      this.errorMessage = ''
      this.request({
        url: this.endpoint('saleReports/reports/sales/net'),
        method: 'get',
        params,
        success: (data) => {
          this.metrics.sales_net.value = data.value || 0
          this.metrics.sales_net.rangeLabel = this.rangeLabelFromResponse(data)
          this.loading.sales_net = false
        },
        error: () => {
          this.loading.sales_net = false
          this.errorMessage = 'خطا در دریافت فروش خالص.'
        }
      })
    },

    fetchProfitGross() {
      const params = this.buildParams()
      if (!params) return
      this.loading.profit_gross = true
      this.errorMessage = ''
      this.request({
        url: this.endpoint('saleReports/reports/profit/gross'),
        method: 'get',
        params,
        success: (data) => {
          this.metrics.profit_gross.value = data.value || 0
          this.metrics.profit_gross.rangeLabel = this.rangeLabelFromResponse(data)
          this.loading.profit_gross = false
        },
        error: () => {
          this.loading.profit_gross = false
          this.errorMessage = 'خطا در دریافت سود ناخالص.'
        }
      })
    },

    // === آمار سریع ===
    fetchQuickStats() {
      const params = this.buildParams()
      if (!params) return
      this.loading.sidebar_stats = true

      // 1) تعداد سفارش‌ها
      this.request({
        url: this.endpoint('saleReports/reports/orders/count'),
        method: 'get',
        params,
        success: (data) => { this.quick.orders_count = data.value || 0 },
        error: () => {},
      })

      // 2) هزینه کل ارسال
      this.request({
        url: this.endpoint('saleReports/reports/shipping/total'),
        method: 'get',
        params,
        success: (data) => { this.quick.shipping_total = data.value || 0 },
        error: () => {},
      })

      // 3) تعداد کل آیتم‌ها
      this.request({
        url: this.endpoint('saleReports/reports/items/quantity'),
        method: 'get',
        params,
        success: (data) => {
          this.quick.items_quantity = data.value || 0
          this.loading.sidebar_stats = false
        },
        error: () => {
          this.loading.sidebar_stats = false
        },
      })
    },

    // === تاپ‌لیست‌ها ===
    fetchTopProductsRevenue() {
      const params = this.buildParams()
      if (!params) return
      params.limit = this.TOP_LIMIT
      this.loading.top_by_revenue = true
      this.request({
        url: this.endpoint('saleReports/reports/products/top-by-revenue'),
        method: 'get',
        params,
        success: (data) => {
          this.topProductsByRevenue = (data.results || [])
          this.loading.top_by_revenue = false
        },
        error: () => {
          this.topProductsByRevenue = []
          this.loading.top_by_revenue = false
        }
      })
    },

    fetchTopProductsQuantity() {
      const params = this.buildParams()
      if (!params) return
      params.limit = this.TOP_LIMIT
      this.loading.top_by_quantity = true
      this.request({
        url: this.endpoint('saleReports/reports/products/top-by-quantity'),
        method: 'get',
        params,
        success: (data) => {
          this.topProductsByQuantity = (data.results || [])
          this.loading.top_by_quantity = false
        },
        error: () => {
          this.topProductsByQuantity = []
          this.loading.top_by_quantity = false
        }
      })
    },

    // Export
    exportCSV() {
      const tab = this.activeTab
      const map = {
        sales_gross: { title: 'فروش ناخالص', key: 'sales_gross' },
        sales_net: { title: 'فروش خالص', key: 'sales_net' },
        profit_gross: { title: 'سود ناخالص', key: 'profit_gross' },
      }
      const meta = map[tab]
      const metric = this.metrics[meta.key]
      const rows = [
        ['metric', 'value', 'range', 'from', 'to'],
        [meta.title, metric.value, metric.rangeLabel, this.filters.from || '', this.filters.to || ''],
      ]
      const csv = rows.map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(',')).join('\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `${meta.key}.csv`
      a.click()
      URL.revokeObjectURL(url)
    }
  }
}
</script>

<style scoped>
/* Custom styles for enhanced visual hierarchy */
.shadow-xs {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.from-gray-25 {
  --tw-gradient-from: #fcfcfd;
  --tw-gradient-to: rgba(252, 252, 253, 0);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

/* Smooth transitions for all interactive elements */
* {
  transition-property: color, background-color, border-color, transform, box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

button:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
